'use client';

import { useEffect } from 'react';

interface CspViolationReporterProps {
  /** Enable with NEXT_PUBLIC_DEBUG_CSP_VIOLATIONS=1 at build time */
  enabled: boolean;
}

/**
 * Logs Content-Security-Policy violations in the browser for debugging allowlists.
 * Does not log request bodies or cookies.
 */
export function CspViolationReporter({ enabled }: CspViolationReporterProps) {
  useEffect(() => {
    if (!enabled || typeof document === 'undefined') {
      return;
    }

    const onViolation = (e: SecurityPolicyViolationEvent) => {
      console.warn('[CSP violation]', {
        violatedDirective: e.violatedDirective,
        blockedURI: e.blockedURI,
        sourceFile: e.sourceFile ?? '',
        lineNumber: e.lineNumber ?? 0,
        disposition: e.disposition,
      });
    };

    document.addEventListener('securitypolicyviolation', onViolation);
    return () => document.removeEventListener('securitypolicyviolation', onViolation);
  }, [enabled]);

  return null;
}
